export default {
  DEFAULT: ["Mr", "Mrs", "Rather not say"],
  //FMM: ["Mr", "Mrs"],
}
